export default function RefundPolicyPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 my-16">
      <h1 className="text-4xl font-bold mb-2">Refund Policy</h1>

      <p className="text-gray-500 mb-8">Last updated: May 9, 2026</p>

      <div className="bg-gray-100 border border-gray-200 rounded-2xl p-5 mb-10">
        <p className="text-sm leading-7">
          <span className="font-semibold">Important:</span> Subscriptions can be
          cancelled at any time. Cancellation prevents future billing, but
          access will continue until the end of the current billing cycle.
        </p>
      </div>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">No Refund Policy</h2>

        <p className="mb-4 leading-7">
          Due to the low-cost nature of our subscription service ($1.29/month),
          payments are generally non-refundable except where required by
          applicable law.
        </p>

        <p className="leading-7">
          We encourage users to review the app features before subscribing.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          Subscription Cancellation
        </h2>

        <p className="mb-4 leading-7">
          You may cancel your subscription at any time through your account
          settings or app store subscription settings.
        </p>

        <ul className="list-disc pl-6 space-y-3 leading-7">
          <li>You will not be charged again for the next billing cycle.</li>

          <li>
            Your subscription benefits remain active until the current billing
            period ends.
          </li>

          <li>
            Access automatically expires at the end of the paid billing cycle.
          </li>
        </ul>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Billing Issues</h2>

        <p className="leading-7">
          If you believe you were charged incorrectly or experienced a billing
          issue, please contact <strong>help@expensehut.com</strong>
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>

        <p className="mb-3 leading-7">
          If you have any questions regarding this Refund Policy, please contact
          us at:
        </p>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 inline-block">
          <p className="font-medium">help@expensehut.com</p>
        </div>
      </section>
    </div>
  );
}
